import { render, staticRenderFns } from "./IssuesFilter.vue?vue&type=template&id=1a41af86&scoped=true"
import script from "./IssuesFilter.vue?vue&type=script&lang=js"
export * from "./IssuesFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a41af86",
  null
  
)

export default component.exports